import "./App.scss";
// REACT; REDUX; ROUTER
import { HashRouter } from "react-router-dom";
// COMPONENTS & FUNCTIONS
import Navbar from "./layout/navbar/Navbar";
import Footer from "./layout/footer/Footer";
import Main from "./layout/main/Main";
import NotificationUnit from "./components/units/NotificationUnit";
import { useState } from "react";
import { Notification } from "./interface/functionalityInterface";

/*
APP COMPONENT INFORMATION
  We use HashRouter here instad of BrowserRouter since this is a relatively small client side application
  The app consist of the following three LAYOUT component =>
    - Navbar for navigation and header
    - Main with all the content based on the route user chooses
    - Footer
*/

export default function App() {
  const [notification, setNotification] = useState<Notification>();

  const handleNotification = (notification: Notification) => {
    setNotification({
      type: notification.type,
      message: notification.message,
    });
  };
  // :::::: JSX ::::::
  return (
    <div className="app">
      <HashRouter>
        <NotificationUnit {...notification} />
        <Navbar />
        <Main showNotification={handleNotification} />
        <Footer />
      </HashRouter>
    </div>
  );
}
